import './styles/Modal.scss';

import { Cancel } from '@mui/icons-material';
import { Grid, IconButton, Modal as MaterialModal, ModalProps } from '@mui/material';

import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import { actions as FormErrorActions } from 'app/containers/Dashboard/FormError/slice';

interface Props extends ModalProps {
  headline?: string;
  width?: 'full' | 'half' | 'small';
  onCancel?: Function;
  disabledCancel?: boolean;
}

export function Modal(props: Props) {
  const dispatch = useDispatch();

  const { disabledCancel, ...restProps } = props;

  return (
    <MaterialModal
      {...restProps}
      className={clsx('modal')}
      onClose={(event, reason) => {
        if (props.onClose) {
          props.onClose(event, reason);
        }
        dispatch(FormErrorActions.close());
      }}
    >
      <Grid
        container
        className={clsx('modal__inner', {
          'modal__inner--full': props.width === 'full',
          'modal__inner--half': props.width === 'half',
          'modal__inner--small': props.width === 'small'
        })}
      >
        {props.headline && (
          <Grid container>
            <Grid container className="modal__inner__heading">
              <Grid item xs={6}>
                {props.headline}
              </Grid>
              {props.onCancel && (
                <Grid item xs={6}>
                  <Grid container justifyContent="flex-end">
                    <IconButton
                      size="small"
                      disabled={props.disabledCancel}
                      onClick={() => {
                        dispatch(FormErrorActions.close());
                        if (props.onCancel !== undefined) {
                          props.onCancel();
                        }
                      }}
                      style={!props.disabledCancel ? { color: 'white' } : undefined}
                    >
                      <Cancel />
                    </IconButton>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        <div className="modal__inner__body">{props.children}</div>
      </Grid>
    </MaterialModal>
  );
}
